<p class="basis-full text-center mb-1.5 xl:mb-2 print:hidden" v-if="layoutType !== 'list'">
    <span v-if="totalResults">
        Showing
        <span> {{ results.length }} out of {{ totalResults }} results.</span>
        <span v-if="activeFilters.length">for
            <span v-for="(filter, index) in activeFilters" :key="index">
                <b class="text-primary-dark"><q>{{ filter }}</q></b><span v-if="index < activeFilters.length - 1">, </span>
            </span>
        </span>
    </span>
    <span v-else>No results found.</span>
    <button v-if="activeFilters.length" class="clear" @click="clearSelectedFilters">&nbsp;Reset Filters?</button>
</p>
